<template>
  <div>
    <h5>Dispatcher Report</h5>

    <b-card class="mb-4">
      <b-form inline @submit.prevent="submit">
        <ReportPeriodFilter
          :period-type.sync="periodType"
          :time-period.sync="timePeriod"
          :selected-dates.sync="selectedDates"
          :time-options="timeOptions"
          :date-config="fltConfig"
        />

        <!-- <b-select class="custom-select ml-5" v-model="filterType" :options="dataOptions" /> -->

        <button class="btn btn-primary ml-3">Show Report</button>
      </b-form>
    </b-card>

    <LoadingIndicator v-if="loading" centered />

    <span v-if="empty">No records found</span>

    <b-card class="mb-4" v-if="!loading && items.length">
      <b-table striped hover :items="items" :fields="fields" caption-top>
        <template #table-caption>
          <span v-if="form.dispatchedStart">Dispatched from {{ form.dispatchedStart }} till {{ form.dispatchedEnd }}</span>
          <span v-if="form.createdStart">Created from {{ form.createdStart }} till {{ form.createdEnd }}</span>
        </template>
        <template #cell(dispatchUserId)="data">
          <b-link v-if="data.value" :to="userLink(data.value)" target="_blank">{{ data.item.user ? data.item.user.name : '' }}</b-link>
        </template>
        <template #custom-foot="data">
          <b-tr>
            <b-th v-for="field in data.fields" :key="field.key">{{ field.key == 'dispatchUserId' ? 'Totals' : formatReportValue(field.key, totals[field.key]) }}</b-th>
          </b-tr>
        </template>

        <template #cell(show_details)="row">
          <b-btn size="xs" variant="secondary" @click.prevent="toggleDetails(row)">
            {{ row.detailsShowing ? 'Hide' : 'Zoom' }}
          </b-btn>
        </template>
        <template #row-details="row">
          <b-card>
            <LoadingIndicator v-if="row.item.loading" centered />
            <b-table v-if="row.item.rows.length" striped hover :items="row.item.rows" :fields="detailsFields" :tbody-tr-class="rowClass" class="mb-0">
              <template #cell(id)="data">
                <b-link :to="orderLink(data.item)" target="_blank">{{ data.value }}</b-link>
              </template>
            </b-table>
          </b-card>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import { tableFields } from '@/mixins/methods';
import { ApiClient } from '@/api/ApiClient';
import LoadingIndicator from '@/components/shared/LoadingIndicator';
import permissionsMixin from '/src/mixins/permissions';
import ReportPeriodFilter from '@/components/pages/reports/ReportPeriodFilter';
import moment from 'moment';

export default {
  name: 'ReportSales',
  data() {
    return {
      loading: false,
      empty: false,
      items: [],
      totals: {},
      periodType: 'list',
      filterType: 2,
      timePeriod: 1,
      selectedDates: null,
      form: {
        createdStart: null,
        createdEnd: null,
        dispatchedStart: null,
        dispatchedEnd: null,
      },
      fltConfig: {
        mode: 'range',
        dateFormat: 'Y-m-d',
        altInput: true,
        altFormat: 'm/d/Y',
        allowInput: true,
      },
      timeOptions: [
        { text: 'Current month', value: 1 },
        { text: 'Last month', value: 2 },
        { text: 'Current quarter', value: 3 },
        { text: 'Last quarter', value: 4 },
        { text: 'Current year', value: 5 },
        { text: 'All time', value: 6 },
      ],
      dataOptions: [
        { text: 'Created orders - during time frame', value: 1 },
        { text: 'Dispatched orders - during time frame', value: 2 },
      ],
      fields: [
        {
          key: 'dispatchUserId',
          label: 'User',
          sortable: false,
        },
        {
          key: 'canceledCount',
          label: 'Canceled',
          sortable: true,
        },
        {
          key: 'issuesCount',
          label: 'Issues',
          sortable: true,
        },
        {
          key: 'dispatchedCount',
          label: 'Dispatched',
          sortable: true,
        },
        {
          key: 'tarrifsTotal',
          label: 'Tariffs',
          sortable: true,
        },
        {
          key: 'carrierPayTotal',
          label: 'Carrier Pay',
          sortable: true,
        },
        {
          key: 'pendingDepositTotal',
          label: 'Unpaid deposit',
          sortable: true,
        },
        {
          key: 'grossProfit',
          label: 'Gross Profit',
          sortable: true,
        },
        {
          key: 'averageProfit',
          label: 'Average Profit',
          sortable: true,
        },
        {
          key: 'approvalsCount',
          label: 'Approvals',
          sortable: true,
        },
        {
          key: 'show_details',
          label: '',
          sortable: false,
        },
      ],
      detailsFields: [
        {
          key: 'id',
          label: 'ID',
          sortable: true,
        },
        {
          key: 'source',
          label: 'Source',
          sortable: true,
        },
        {
          key: 'type',
          label: 'Type',
          sortable: true,
        },
        {
          key: 'status',
          label: 'Status',
          sortable: true,
        },
        {
          key: 'tarrifs',
          label: 'Tarrif',
          sortable: true,
        },
        {
          key: 'customerPaidCompany',
          label: 'Deposit paid',
          sortable: true,
        },
        {
          key: 'carrierPay',
          label: 'Carrier pay',
          sortable: true,
        },
        {
          key: 'pendingDeposit',
          label: 'Unpaid deposit',
          sortable: true,
        },
        {
          key: 'signedAt',
          label: 'Dispatched At',
          sortable: true,
        },
      ],
    };
  },
  mixins: [tableFields, permissionsMixin],
  components: {
    LoadingIndicator,
    ReportPeriodFilter,
  },
  methods: {
    async submit(e) {
      e.preventDefault();
      this.fetchDispatchSalesReport();
    },
    toggleDetails(row) {
      row.toggleDetails();
      if (row.item._showDetails) {
        this.fetchDispatchSalesReportDetails(row.item);
      }
    },
    async fetchDispatchSalesReport() {
      this.prepareDates();
      this.loading = true;
      const response = await ApiClient.reports.dispatchSales({ params: this.form });
      this.loading = false;
      this.items = response.data.data.rows.map(x => {
        x.rows = [];
        x.loading = false;
        return x;
      });
      this.totals = response.data.data.totals;
      this.empty = !this.items.length;
    },
    async fetchDispatchSalesReportDetails(item) {
      this.prepareDates();
      item.loading = true;
      let params = Object.assign({ dispatchUserId: item.dispatchUserId }, this.form);
      const response = await ApiClient.reports.dispatchSalesDetails({ params });
      item.loading = false;
      item.rows = response.data.data.rows;
    },
    userLink(id) {
      return id ? { name: 'UserDetails', params: { id: id } } : {};
    },
    orderLink(item) {
      if (item.leadTypeId == 3) return { name: 'OrderDetails', params: { id: item.id } };
      if (item.leadTypeId == 2) return { name: 'QuoteDetails', params: { id: item.id } };
      if (item.leadTypeId == 1) return { name: 'LeadDetails', params: { id: item.id } };
      return null;
    },
    prepareDates() {
      let parts = [];
      if (this.periodType == 'list') {
        if (this.timePeriod == 1) {
          parts.push(moment().startOf('month').format('YYYY-MM-DD'));
          parts.push(moment().endOf('month').format('YYYY-MM-DD'));
        }
        if (this.timePeriod == 2) {
          parts.push(moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'));
          parts.push(moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'));
        }
        if (this.timePeriod == 3) {
          parts.push(moment().startOf('quarter').format('YYYY-MM-DD'));
          parts.push(moment().endOf('quarter').format('YYYY-MM-DD'));
        }
        if (this.timePeriod == 4) {
          parts.push(moment().subtract(1, 'quarter').startOf('quarter').format('YYYY-MM-DD'));
          parts.push(moment().subtract(1, 'quarter').endOf('quarter').format('YYYY-MM-DD'));
        }
        if (this.timePeriod == 5) {
          parts.push(moment().startOf('year').format('YYYY-MM-DD'));
          parts.push(moment().endOf('year').format('YYYY-MM-DD'));
        }
        if (this.timePeriod == 6) {
          parts.push(null);
          parts.push(null);
        }
      } else {
        if (!this.selectedDates) return;
        parts = this.selectedDates.split(' to ');
        if (parts.length < 2) parts.push(parts[0]);
      }

      this.form.createdStart = null;
      this.form.createdEnd = null;
      this.form.dispatchedStart = null;
      this.form.dispatchedEnd = null;

      if (this.filterType == 1) {
        this.form.createdStart = parts[0];
        this.form.createdEnd = parts[1];
      } else {
        this.form.dispatchedStart = parts[0];
        this.form.dispatchedEnd = parts[1];
      }
    },
    rowClass(item, type) {
      if (type === 'row' && item && item.tasksExists) return 'text-danger';
      return null;
    },
  },
};
</script>

<style lang="scss" scoped>
.text-danger a {
  color: inherit;
}
</style>
